import {
    REQUEST_UPDATE_INTERESTS,
    SUCCESS_UPDATE_INTERESTS,
    FAILURE_UPDATE_INTERESTS,
    RESET_FORM_SUBMIT_UPDATE_INTERESTS,
    REQUEST_USER_CRITERIA,
    RECEIVE_USER_CRITERIA,
    FAILURE_USER_CRITERIA
} from './constants';
import { combineReducers } from 'redux';
import { REDUX_FORM_CHANGE } from '../../../constants';

/** State shape
{
    fetching: false,
    successProfileUpdateRequestSubmit: false,
    errorMessage: '',
    usercriteria {
        idCriteria
    }
}
 */

const successInterestsUpdateRequestSubmit = (state = false, action) => {
    switch (action.type) {
        case SUCCESS_UPDATE_INTERESTS:
            return true;
        case REQUEST_UPDATE_INTERESTS:
        case FAILURE_UPDATE_INTERESTS:
        case RESET_FORM_SUBMIT_UPDATE_INTERESTS:
        case REDUX_FORM_CHANGE:
            return false;
        default:
            return state;
    }
};

const usercriteria = (state = {}, action) => {
    switch (action.type) {
        case RECEIVE_USER_CRITERIA:
            return { ...state, [action.criteriaType]: action.response.payload };
        default:
            return state;
    }
};

const fetching = (state = false, action) => {
    switch (action.type) {
        case REQUEST_USER_CRITERIA:
            return true;
        case FAILURE_USER_CRITERIA:
        case RECEIVE_USER_CRITERIA:
            return false;
        default:
            return state;
    }
};

// update occuring
const updating = (state = false, action) => {
    switch (action.type) {
        case REQUEST_UPDATE_INTERESTS:
            return true;
        case FAILURE_UPDATE_INTERESTS:
        case SUCCESS_UPDATE_INTERESTS:
        case RESET_FORM_SUBMIT_UPDATE_INTERESTS:
            return false;
        default:
            return state;
    }
};

const error = (state = '', action) => {
    switch (action.type) {
        case FAILURE_UPDATE_INTERESTS:
        case FAILURE_USER_CRITERIA:
            return action.response.message;
        case REQUEST_UPDATE_INTERESTS:
        case REQUEST_USER_CRITERIA:
        case SUCCESS_UPDATE_INTERESTS:
        case RECEIVE_USER_CRITERIA:
        case RESET_FORM_SUBMIT_UPDATE_INTERESTS:
            return '';
        default:
            return state;
    }
};

export default combineReducers({
    successInterestsUpdateRequestSubmit,
    usercriteria,
    fetching,
    updating,
    error
});



// WEBPACK FOOTER //
// ./src/services/account/myinterests/reducer.js